export const Mine = {
  path: "/Mine",
  name: "Mine",
  component: () => import("./Mine.vue"),
  meta: {
    title: "个人中心",
  },
};

export const attestation = {
  path: "/attestation",
  name: "attestation",
  component: () => import("./attestation/attestation.vue"),
  meta: {
    title: "实名认证",
  },
};

export const myWorkOrder = {
  path: "/myWorkOrder",
  name: "myWorkOrder",
  component: () => import("./myWorkOrder/myWorkOrder.vue"),
  meta: {
    title: "我的交办单",
  },
};

export const orderDetail = {
  path: "/orderDetail/:id",
  name: "orderDetail",
  component: () => import("./myWorkOrder/orderDetail.vue"),
  meta: {
    title: "交办单详情",
  },
};
export const myEventOrder = {
  path: "/myEventOrder",
  name: "myEventOrder",
  component: () => import("./myEventOrder/myEventOrder.vue"),
  meta: {
    title: "我的事件工单",
  },
};
export const eventDetail = {
  path: "/eventDetail/:id",
  name: "eventDetail",
  component: () => import("./myEventOrder/eventDetail.vue"),
  meta: {
    title: "工单详情",
  },
};
export const myFile = {
  path: "/myFile",
  name: "myFile",
  component: () => import("./myFile/myFile.vue"),
  meta: {
    title: "我的存档",
  },
};
export const fileDetail = {
  path: "/fileDetail",
  name: "fileDetail",
  component: () => import("./myFile/fileDetail.vue"),
  meta: {
    title: "存档详情",
  },
};
export const errorPage = {
  path: "/errorPage",
  name: "errorPage",
  component: () => import("./errorPage/errorPage.vue"),
  meta: {
    title: "无权访问",
  },
};

export const updateFile = {
  path: "/updateFile",
  name: "updateFile",
  component: () => import("./myFile/updateFile.vue"),
  meta: {
    title: "存档修改",
  },
};
